module.exports = __webpack_public_path__ + "img/UserInterface.c9e35171.jpg";